var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleeping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#fefae0",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320 630 c0 -5 7 -10 16 -10 15 0 15 -2 0 -25 -22 -33 -21 -35 17 -34 17 1 24 3 15 6 -21 5 -22 12 -3 37 8 10 12 23 9 27 -7 12 -54 11 -54 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 562 c-42 -45 -57 -74 -72 -144 -12 -54 11 -27 27 31 12 42 29 72 55 100 40 43 69 54 58 24 -29 -75 -8 -164 52 -226 35 -36 37 -41 41 -117 3 -77 2 -80 -19 -80 -66 0 -172 96 -186 170 -8 37 -24 50 -24 19 0 -70 96 -179 179 -203 l46 -13 5 -59 5 -59 38 -3 c45 -4 84 18 92 51 4 13 19 28 36 34 16 6 29 16 29 22 0 14 -17 14 -25 1 -3 -5 -13 -10 -21 -10 -10 0 -14 13 -14 46 0 27 -4 43 -10 39 -5 -3 -10 -35 -10 -70 0 -77 -15 -98 -69 -93 l-36 3 -3 145 c-2 115 -6 148 -18 162 -15 16 -14 18 10 24 46 11 56 0 56 -61 0 -30 5 -55 10 -55 6 0 10 18 10 40 0 38 2 40 30 40 19 0 40 -9 55 -25 21 -20 25 -34 25 -85 0 -33 4 -60 10 -60 6 0 10 12 10 26 0 14 11 40 24 57 61 80 49 135 -20 90 -24 -15 -27 -15 -54 0 -15 9 -40 17 -54 17 -16 0 -30 8 -37 21 -11 21 -39 23 -98 8 -7 -2 -22 13 -35 36 -20 38 -25 95 -14 175 6 45 -33 37 -84 -18z m415 -259 c-4 -10 -13 -29 -22 -42 -14 -22 -15 -22 -22 -5 -12 31 -10 40 14 52 32 15 37 14 30 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 570 c-3 -5 1 -10 10 -10 12 0 15 -5 10 -17 -19 -47 -18 -53 9 -53 14 0 26 5 26 10 0 6 -7 10 -15 10 -14 0 -14 3 1 25 8 13 13 29 9 35 -8 13 -42 13 -50 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 490 c-3 -5 1 -10 10 -10 12 0 15 -5 10 -17 -19 -47 -18 -53 9 -53 14 0 26 5 26 10 0 6 -7 10 -16 10 -15 0 -15 2 0 25 9 14 14 30 11 35 -8 13 -42 13 -50 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleeping);
export default __webpack_public_path__ + "static/media/sleeping.8fd5ae8a0a46c0f71abe2d33dabc9711.svg";
export { ForwardRef as ReactComponent };